import axios from 'axios';
import qs from 'qs';
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
console.log(source);

const config = { headers: {'Content-Type': 'application/json', 'Cache-Control': 'no-cache'}};
//退出
export const logOut = ()=>{
    return new Promise((resolve, reject)=>{
        axios.delete('/logout').then(response=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};
// 登录接口
export const logIn = (data) => {
    return new Promise((resolve, reject)=>{
        axios.post('/login',data).then(response=>{
            console.log(response, 'original response');
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 刷新token
export const refreshToken = ()=>{
    return new Promise((resolve, reject)=>{
        axios.post('/refresh').then(response=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};



/*
* 获取用户信息
 */
export const GetUserInfo = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me',config).then((response)=>{
        // axios.get('/student/me',config).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};
//NOIP表格接口
export const GetNoipProblems = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/noip/problems', {params:query}).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};
//NOIP标签下拉框接口
export const GetNoiptags = ()=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/noip/tags').then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};


// 获取必修课列表
export const GetRequiredList = () => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/recorded/required`).then((resp) => {
            if(resp.code === 200) {
                resolve(resp);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 获取艺术编程课列表
export const GetArtist = () => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/recorded/art`).then((resp) => {
            if(resp.code === 200) {
                resolve(resp);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 获取启蒙课列表
export const GetEnlightenment = () => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/recorded/enlightenment`).then((resp) => {
            if(resp.code === 200) {
                resolve(resp);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 获取启蒙课直播列表
export const GetEnlightenLiveList = () => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/recorded/enlightenment`).then((resp) => {
            if(resp.code === 200) {
                resolve(resp);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

//记录进入直播间的时间
export const RecordEnterLive = (id) => {
    return new Promise ((resolve, reject) => {
        axios.put(`/student/smallclass/${id}/entry-live`).then((resp) => {
            if(resp.code === 200) {
                resolve(resp);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};
/*
* 我的作品
 */
export const GetMyWork = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me/works',{params: query}).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

//NOIP单个题目接口
export const GetNoipSingleProblem = (id,query)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/noip/problems/${id}`,{params: query}).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};


/*
* 获取手机验证码
 */
export const GetAuthCode = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'post',
            url: '/student/me/identify-code',
            params: query,
            data: data
        }).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};
//NOIP单个题目提交接口
export const GetNoipSolution = (data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/noip/solution',data).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};
/*
* 修改绑定手机号
 */
export const editMobile = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'patch',
            url: '/student/me/mobile',
            params: query,
            data: data
        }).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

/*
* 修改个人信息
 */
export const editUserInfo = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'put',
            url: '/student/me',
            headers: {'Content-type': 'application/x-www-form-urlencoded'},
            params: query,
            data: data
        }).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

/*
**
** @author luoyc
** @created 2018/8/6
*/
// 修改个人信息

export const editPwd = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'put',
            url: '/student/me',
            headers: {'Content-type': 'application/x-www-form-urlencoded'},
            params: query,
            data: data
        }).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

/*
* 我的订单
 */
export const GetMyOrder = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me/orders',{params: query}).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

/*
* 我的订单
 */
export const delOrder = (id,query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'patch',
            url: `/student/me/orders/${id}`,
            params: query,
            // data: data
        }).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

/*
* 作品详情
 */
export const GetWorkDetail = (id,query)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/work/${id}`,{params: query}).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

// 手机端获取作品详情
export const GetMobileWorkDetail = (id,query)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/work/${id}`,{params: query}).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};
/*
* 获取评论
 */
export const GetComment = (id,query)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/work/${id}/get-comment`,{params: query}).then((response)=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

/*
* 保存评论
 */
export const saveComment = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'post',
            url: `/student/work/save-comment`,
            params: query,
            data: data
        }).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};
//获取上课页面接口
export const GetChapter = (id)=>{
    return new Promise((resolve, reject)=> {
        axios.get(`/student/recorded/show/${id}`).then((response) => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            // console.log(error);
            reject(error);
        });
    });
};
/**
 * 保存Python作品
 */
export const SavePython = (data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/work/save-python', data).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};
/**
 * 保存scratch、scratch-arduino作品
 */
export const SaveScratch = (data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/save-work', data).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

/*
* 作品点赞
 */
export const likeWork = (id)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'put',
            url: `/student/work/${id}/thumbs-up`,
            // params: query,
            // data: data
        }).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

export const GetMyWorks = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me/works',{params: query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

/*
* 专题课列表
 */
export const GetSpecialLesson = (id,query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me/electives',{params: query}).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};

/*
* 试听课列表
 */
export const GetTryLesson = (id,query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me/trials',{params: query}).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
        }).catch((error)=>{
            console.log(error);
            reject(error);
        });
    });
};
//记录录播课上课记录
export const GetTranscribe = (data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/watches/recorded',data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};


//大家的新作品
export const GetEveryOneNewWork = ()=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/everyone-new-work').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
        }).catch(error=>{
            reject(error);
        });
    });
};

//NOIP提交记录接口
export const GetSolutionRecent = (id)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/noip/solution/recent/${id}`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
        }).catch(error=>{
            reject(error);
        });
    });
};

// 哈克尼斯相关接口
export const GetHarknessClass = (class_id) => {
    return new Promise((resolve, reject) => {
        axios.get(`/student/smallclass/${class_id}`).then((resp) => {
            if(resp.code == 200) {
                resolve(resp.data);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

//NOIP排行榜接口
export const GetNoipRank = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/noip/rankings',{params:query}).then(response=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

//学习进度
export const GetUnfinishClass = ()=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me/unfinish-class').then(response=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};
//NOIP评测列表接口
export const GetNoipSolutions = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/noip/solutions',{params:query}).then(response=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 获取排行榜
export const GetRank = (id) => {
    return new Promise((resolve, reject) => {
        axios.get(`/student/smallclass/${id}/vote`).then((resp) => {
            if(resp.code == 200) {
                resolve(resp.data);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

//查看答案解析
export const QuizeAnswer = (query) => {
    return new Promise((resolve, reject) => {
        axios.get('/student/reports/quize-answer', {params: query}).then((resp) => {
            if (resp.code == 200) {
                resolve(resp);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

//PYTHON提交练习题
export const PYTHONPractice = (data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/reports/submit',data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};


// 获取班级作业列表,班级优秀作业列表传参数 is_good=1
export const GetClassWorkList = (id, query) => {
    return new Promise((resolve, reject) => {
        axios.get(`/student/smallclass/${id}/homework`, {params: query}).then((resp) => {
            if(resp.code == 200) {
                resolve(resp.data);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

//PYTHON测试报告获取
export const GetPythonReports = (id)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/reports/list/${id}`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 获取自己的作品列表
export const GetPersonalWorkList = (class_id, class_student_id) => {
    return new Promise((resolve, reject) => {
        axios.get(`/student/smallclass/${class_id}/homework/${class_student_id}`).then((resp) => {
            if(resp.code == 200) {
                resolve(resp.data);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

//PYTHON测试报告详情获取
export const GetPythonReportsDetail = (id)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/reports/show/${id}`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 设置状态在线
export const SetOnline = (class_id) => {
    return new Promise((resolve, reject) => {
        axios.put(`/student/smallclass/${class_id}/alive`).then((resp) => {
            if(resp.code == 200) {
                resolve(resp.data);
            }
            reject(resp);
        }).catch((error) => {
            reject(error);
        });
    });
};

//是有python助手运行创作代码
export const PythonCreate = (data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('https://local.codepku.com:26337/run',
            qs.stringify(data),
            {headers: {'Content-Type': 'application/x-www-form-urlencoded'},withCredentials: false}
        ).then(response=>{
            console.log(response);
            resolve(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

//管理作品
export const DeleteWork = (ids)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};


//批量删除作品
export const delWorks = (data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            method: 'delete',
            url: '/student/work/works-batch',
            data: data
        })
            .then(response=>{
                if(true){
                    resolve(response.data);
                }
                reject(response);
            }).catch(error=>{
            reject(error);
        });
    });
};

//删除作品
export const delWork = (id)=>{
    return new Promise((resolve, reject)=>{
        axios.delete(`/student/work/${id}`)
            .then(response=>{
                if(true){
                    resolve(response.data);
                }
                reject(response);
            }).catch(error=>{
            reject(error);
        });
    });
};

//取消点赞
export const cancelLike = (id)=>{
    return new Promise((resolve, reject)=>{
        axios.delete(`/student/work/${id}/thumbs-down`)
            .then(response=>{
                if(true){
                    resolve(response.data);
                }
                reject(response);
            }).catch(error=>{
            reject(error);
        });
    });
};


// 班级优秀作业
// 获取默认头像列表
export const getAvatars = ()=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/me/avatars').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 修改头像
export const editAvatars = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            url: '/student/me/avatars',
            method: 'post',
            params: query,
            data: data
        }).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 检查微信是否绑定
export const IsBindWechat = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            url: '/student/me/check-wechat-bind',
            method: 'post',
            params: query,
            data: data
        })
            .then(response=>{
                if(true){
                    resolve(response.data);
                }
                reject(response);
            }).catch(error=>{
            reject(error);
        });
    });
};

// 解绑
export const UnBind = (query,data)=>{
    return new Promise((resolve, reject)=>{
        axios({
            url: '/student/me/social-account',
            method: 'delete',
            params: query,
            data: data
        })
            .then(response=>{
                if(true){
                    resolve(response.data);
                }
                reject(response);
            }).catch(error=>{
            reject(error);
        });
    });
};
//记录用户点击的课时
export const RecordLearn = (data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/watches/click',data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

//获取测试运行的结果
export const TestResult = (id)=>{
    return new Promise((resolve, reject)=>{
        axios.get(`/student/noip/solution/test-result/${id}`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 圆桌获取待上传作业列表
export const GetToBeUploadedWorks = (class_id, query) => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/class_time/${class_id}/upload-list`,{params: query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};
//获取指定题目的状态
export const NoipSolutionsResult = (query)=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/noip/solution/results',{params:query}).then(response=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};
// 上传作业接口
export const UploadWork = (class_id, data) => {
    return new Promise ((resolve, reject) => {
        axios.post(`/student/class_time/${class_id}/upload-homework`, data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};
// 获取已交作业
export const getWorkList = (class_time_id, query) => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/class_time/${class_time_id}/homework`, {params:query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 补交作业接口
export const MakeUpWork = (class_id, data) => {
    return new Promise ((resolve, reject) => {
        axios.post(`/student/smallclass/${class_id}/makeup-homework`, data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 上传文件接口
export const UploadFile = (class_id, data) => {
    return new Promise ((resolve, reject) => {
        axios.post(`/student/smallclass/${class_id}/upload`, data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 设置优秀作业
export const ToggleGood = (class_id, homework_id) => {
    return new Promise ((resolve, reject) => {
        axios.put(`/student/smallclass/${class_id}/good/${homework_id}`).then(response=>{
            if(true){
                resolve(response.data);
            };
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
/**
 * 上传作品
 */
export const CreateWork = (data)=>{
    const config = {
        onUploadProgress: function(progressEvent) {
            if(progressEvent.lengthComputable){
                var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                console.log(percentCompleted);
            }
        }
    };
    return new Promise((resolve, reject)=>{
        axios.post('/student/work/upload-work', data, config).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};
//移动端
export const mCreateWork = (data,config)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/work/upload-work', data, config).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

//python网站创建剩余次数
export const GetPythonTimes = ()=>{
    return new Promise((resolve, reject)=>{
        axios.get('/student/center/python-condition').then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 保存python网站的编辑
export const EditPythonWeb = (id,data)=>{
    return new Promise((resolve, reject)=>{
        axios.post('/student/center/update-python-web/'+ id,data).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 给同学投票
export const ToggleVote = (class_id, student_id) => {
    return new Promise ((resolve, reject) => {
        axios.put(`/student/smallclass/${class_id}/vote/${student_id}`).then(response=>{
            if(true){
                resolve(response.data);
            };
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
/**
 * 浏览作品的浏览量
 */
export const addViewCount = (id, data)=>{
    return new Promise((resolve, reject)=>{
        axios.put(`/student/work/${id}/view-count`, data).then((response)=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch(error=>{
            reject(error);
        });
    });
};

// 获取班级参考作业
export const GetReferenceWorks = (class_id) => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/smallclass/${class_id}/reference-homework`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 记录用户点击缺勤回放的动作
export const RecordWatch = (data) => {
    return new Promise ((resolve, reject) => {
        axios.post(`/student/me/records/watch`,data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取班级在线情况
export const CheckOnline = (class_id) => {
    return new Promise ((resolve, reject) => {
        axios.get(`/student/smallclass/${class_id}/alive`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 记录查看回放的动作
export const ReplayWatched = (data) => {
    return new Promise ((resolve, reject) => {
        axios.post(`/student/me/records/watch`, data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 作业访问浏览数接口
export const RecordWorkView = (class_id, homework_id) => {
    return new Promise ((resolve, reject) => {
        axios.put(`/student/smallclass/${class_id}/add-view/${homework_id}`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 删除服务器缓存的作业（图片，视频）
export const DeleteFile = (class_id, upload_file_id) => {
    return new Promise ((resolve, reject) => {
        axios.delete(`/student/smallclass/${class_id}/upload/${upload_file_id}`).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取年级列表
export const GetGrades = () => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/trials/grades').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 个人中心预约录播课
export const BookListenClass = (data) => {
    return new Promise ((resolve, reject) => {
        axios.post('/student/trials/record',data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 所有的作品toke，sign权限判断
export const CheckAccess = (work_id, query) => {
    return new Promise ((resolve, reject) => {
        // axios.get(`/student/detail/${work_id}?entity_id=${class_id}&type=${type}&sign=${sign}&token=${token}`, {params:query}).then(response=>{
            axios.get(`/student/detail/${work_id}`, {params:query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取测试直播间的地址
export const GetTestUrl = (data) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/me/live-test').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 记录进入观看时间
export const RecordEnter = (data) => {
    return new Promise ((resolve, reject) => {
        axios.post('/student/me/record-enter',data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取作品展示列表
export const GetPresentationList = (filter) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area',{params:filter}).then(response=>{
            if(true){
                resolve(response);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取技术文档列表
export const GetDocumentList = (query) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/document',{params:query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取技术文档类型
export const GetDocumentType = (query) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/document/type').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取交流讨论列表
export const GetDiscussList = (query) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/discuss', {params:query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取交流讨论详情
export const GetDiscussDetail = (id) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/discuss/' + id).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 创建交流讨论
export const CreateDiscuss= (data) => {
    return new Promise ((resolve, reject) => {
        axios.post('/student/study-area/discuss', data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 学习指南列表
export const GetCommonProblem= (query) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/common-problem',{params:query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};
// 学习指南详情
export const GetCommonProblemDetail= (id) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/common-problem/' + id).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取交流讨论评论列表
export const GetCommentList= (id=0,pages) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/discuss/comment/'+id,{params:pages}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 交流讨论评论
export const PostComment= (data) => {
    return new Promise ((resolve, reject) => {
        axios.post('/student/study-area/discuss/comment', data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 删除交流讨论
export const DeleteDiscuss= (id) => {
    return new Promise ((resolve, reject) => {
        axios.delete('/student/study-area/discuss/' + id).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取未读消息通知数量
export const GetUnreadMessage =() => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/center/unread').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
  };
//素材列表
export const MaterialList = (type,query) => {
  return new Promise ((resolve,reject) => {
      axios.get(`/student/center/material-list/${type}`,{params:query}).then(response => {
            if(true) {
                resolve(response);
            }
            reject(response);
      }).catch((error) => {
          reject(error);
      });
  });
};
//取消收藏素材
export const CancelMaterial = (id)=>{
    return new Promise((resolve, reject)=>{
        axios.delete(`/student/center/cancel-material-collect/${id}`)
            .then(response=>{
                if(true){
                    resolve(response);
                }
                reject(response);
            }).catch(error=>{
            reject(error);
        });
    });
};

// 获取消息通知列表
export const GetNotificationList =(type) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/center/notification-list/' + type).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 批量删除消息通知
export const DeleteBatchNotice =(data) => {
    return new Promise ((resolve, reject) => {
        axios.delete('/student/center/batch-delete', {data:{notification_ids:data}}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 删除单条通知
export const DeleteSingleNotice =(id) => {
    return new Promise ((resolve, reject) => {
        axios.delete('/student/center/delete-notification/' + id).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

//主页热门讨论
export const MainDiscuss = ()=> {
    return new Promise((resolve,reject)=> {
        axios.get('/student/study-area/discuss').then(response=> {
            if (true) {
                resolve(response);
            }
            reject(response);
        }).catch(error=> {
            reject(error);
        });
    });
};

//获取优惠券列表
export const GetCoupons = (data) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/coupons').then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 获取标签列表
export const GetTags = (query) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/discuss/tag',{params:query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 创建标签
export const CreateTag = (data) => {
    return new Promise ((resolve, reject) => {
        axios.post('/student/study-area/discuss/tag',data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 课程筛选列表
export const GetCourseOptionList = (query) => {
    return new Promise ((resolve, reject) => {
        axios.get('/student/study-area/course-option-list',{params:query}).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
     });
 };

//护眼模式
export const EyesMode = (query) => {
    return new Promise ((resolve,reject) => {
       axios.get('/student/eyes-protection',{params:query}).then(response => {
           if (true) {
               resolve(response.data);
           }
           reject(response);
       }).catch((error) => {
           reject(error);
       });
    });
};
//用户成长体系积分学分列表
export const IntegralCreditList = (type,query) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/center/integral-credit-list/${type}`,{params:query}).then(response => {
            if (true) {
                resolve(response);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 修改作品详情
export const EditWorkDetail = (id,data) => {
    return new Promise ((resolve, reject) => {
        axios.put(`/student/center/edit-work/${id}`,data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};

// 发布作品和取消发布
export const EditPublish= (id,data) => {
    return new Promise ((resolve, reject) => {
        axios.put(`/student/center/is-public/${id}`,data).then(response=>{
            if(true){
                resolve(response.data);
            }
            reject(response);
        }).catch((error)=>{
            reject(error);
        });
    });
};
//用户成长体系签到领积分
export const SingIn = () => {
    return new Promise ((resolve,reject) => {
        axios.post('/student/center/sign-in').then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 学习讨论点赞
export const LikeDiscuss = (id) => {
    return new Promise ((resolve,reject) => {
        axios.put(`/student/study-area/discuss/${id}/like`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
//用户成长体系积分，学分，证书
export const GrowUp = () => {
    return new Promise ((resolve,reject) => {
        axios.get('/student/center/user-growup').then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 查看代码
export const CheckCodePoint = (id,query) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/center/${id}/view-code`,{params:query}).then(response => {
            if (true) {
                resolve(response);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
//帮助中心
export const HelpCenter = (query) => {
    return new Promise ((resolve,reject) => {
        axios.get('/student/help-center',{params:query}).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 查看代码扣分接口
export const ConsumePoint = (id,query) => {
    return new Promise ((resolve,reject) => {
        axios.put(`/student/center/consume-integral/${id}`,query).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
//技术文档代码详情
export const TechnicalDocument = (id) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/study-area/document/${id}`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
//python自动保存
export const AutoSave = (data) => {
    return new Promise ((resolve,reject) => {
        axios.post('/student/auto-save-python',data).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
//保存时获取名字
export const PythonTitle = (id) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/center/get-python-title/${id}`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
//积分兑换接口
export const ExchangeEntry = () => {
    return new Promise ((resolve,reject) => {
        axios.get('/student/exchange/entry').then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
export const Exchange = (data) => {
    return new Promise ((resolve,reject) => {
        axios.post('/student/exchange',data).then(response => {
            if (true) {
                resolve(response);
            }
            reject(response);
        }).catch((error) => {
            // resolve(error);
            reject(error);
        });
    });
};

// 获取小班课列表
export const GetClassList = (small_class) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/smallclass-manage/${small_class}`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 小班课教室参考作业列表
export const GetSmallClassReferenceWorks = (small_class,query) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/smallclass-manage/${small_class}/reference-homework`,{params:query}).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 小班课教室班级作业列表
export const GetSmallClassWorks = (small_class,query) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/smallclass-manage/${small_class}/homework`,{params:query}).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 首页我的班级列表
export const GetMyClasses = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/smallclass-manage/my`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 获取班级投票列表
export const GetSmallClassVote = (small_class,query) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/smallclass-manage/${small_class}/vote`,{params:query}).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 班级教室内观看作品增加点击次数
export const AddViewInSmallClassRoom = (small_class, homework_id) => {
    return new Promise ((resolve,reject) => {
        axios.put(`/student/smallclass-manage/${small_class}/homework/${homework_id}/add-view`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

//表情列表数据
export const GetEmotionData = (small_class_time_id) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/live/${small_class_time_id}/emotion`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 评价老师
export const EvaluateTeacher = (small_class_time_id, data) => {
    return new Promise ((resolve,reject) => {
        axios.put(`/student/smallclass/${small_class_time_id}/evaluation-teacher`, data).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 表情分析的课程列表筛选
export const GetEmotionCourseList = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/smallclass-manage/emotion-course-list`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 表情分析的课程列表筛选
export const getCdnKey = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/temp-secret`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 线下课列表
export const getOfflineList = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/offline/lists`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 练习提交getSmallSubject
export const getSmallSubject = (query) => {
    return new Promise ((resolve,reject) => {
        axios.post('/student/reports/submit',query).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

// 获取试听课
export const getTrials = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/recorded/trials`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 获取试听课
export const GetElectives = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/recorded/electives`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 学校系统接口
// 获取当前用户能观看的课程类型
export const SchoolCourseType = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/recorded/course-types`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 获取线上课程
export const SchoolCourseRequired = (query) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/recorded/lists`,{params:query}).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 自学课程
export const SchoolCourseElectives = () => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/recorded/electives`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 学校系统上传作业
export const SchoolWorks = (id,query) => {
    return new Promise ((resolve,reject) => {
        axios.post(`/student/homework/upload/${id}`, query).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 获取能被上传的作业
export const AllowSchoolWorks = (id,query) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/homework/upload-list/${id}`,{params:query}).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};
// 获取某个课时的作业
export const AllowChapterWorks = (id) => {
    return new Promise ((resolve,reject) => {
        axios.get(`/student/homework/chapter/${id}`).then(response => {
            if (true) {
                resolve(response.data);
            }
            reject(response);
        }).catch((error) => {
            reject(error);
        });
    });
};



// WEBPACK FOOTER //
// ./src/services/getData.js